import { AxiosResponse } from "axios";
import { fork, put, takeLatest } from "redux-saga/effects";
import { FavoritePharmacyDataList } from "../../Apis/AuthApiServices";
import {
  loadingFavoritePharmacyDataList,
  setFavoritePharmacyDataList,
} from "../Slice/FavoritePharmacyDataListSlice";

function* onLoadFavoritePharmacyDataListAsync({ payload }: any) {
  const params = new URLSearchParams();
  let doctorId: any = localStorage.getItem("doctorId");
  params.append("doctorId", doctorId);
  params.append("pageNumber", payload.pageNumber);

  try {
    const result: AxiosResponse = yield FavoritePharmacyDataList(params);
    if (result?.data?.digitalRxStatusCode === 200) {
      yield put(
        setFavoritePharmacyDataList({
          FavoritePharmacyDataListData: result?.data?.response,
          Items: result?.data?.response[0]?.items,
          Pagination: result?.data?.response[0]?.pagination,
          isLoading: false,
          error: false,
        })
      );
    } else {
      yield put(
        setFavoritePharmacyDataList({
          FavoritePharmacyDataListData: [],
          error: false,
          isLoading: false,
          message: result?.data?.digitalRxStatusMessage,
        })
      );
    }
  } catch (error: any) {
    yield put(
      setFavoritePharmacyDataList({
        FavoritePharmacyDataListData: [],
        error: true,
        isLoading: false,
        message: "Try Again After Some Time!",
      })
    );
  }
}

function* onLoadFavoritePharmacyDataList() {
  yield takeLatest(
    loadingFavoritePharmacyDataList.type,
    onLoadFavoritePharmacyDataListAsync
  );
}

const FavoritePharmacyDataListSaga = [fork(onLoadFavoritePharmacyDataList)];
export default FavoritePharmacyDataListSaga;
